import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import type { TableActionSpec } from '@/@vxapp/@Types/ServiceMetadata'

export const CustomersTableActions = [
  {
    id: 'edit',
    title: 'Edit Customer',
    icon: 'tabler-pencil',
    color: 'primary',
    emit: 'edit',
  },
  {
    id: 'view',
    title: 'View Customer',
    icon: 'tabler-eye',
    color: 'primary',
    route: {
      name: PageMeta.Customers.preview.name || '',
      paramKey: 'guid',
      itemKey: 'clientGUID',
    },
    emit: 'view',
  },
] as const satisfies readonly TableActionSpec[]
